<template>
  <v-popover offset="4"
             open-group="comment-popover"
             :open="edit_mode"
             trigger="manual"
             @hide="edit_mode = false"
             popoverClass="comment-popover">
    <IconChat v-tooltip="note" @click.native.stop="start"
              class="comment-icon group-hover:opacity-100"
              :class="{'has-comment': !!note}"/>
    <template slot="popover">
      <div class="grid grid-cols-2 col-gap-4 row-gap-4">
        <div class="col-span-2">
          <BaseTextarea v-model="new_note" :label="$t('commentLabel')" size="sm" ref="input"/>
        </div>
        <BaseButton theme="red" size="sm"
                    :disabled="isSubmitted"
                    @click="save" v-close-popover>
          {{ $t('save') }}
        </BaseButton>
        <BaseButton theme="default" size="sm"
                    @click="cancel" v-close-popover>
          {{ $t('cancel') }}
        </BaseButton>
      </div>
    </template>
  </v-popover>
</template>

<script>
import IconChat from "@/components/icons/IconChat";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseButton from "@/components/UI/BaseButton";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "NoteEdit",
  components: {BaseTextarea, BaseButton, IconChat},
  props: {
    note: {
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isSubmitted: false,
      edit_mode: false,
      new_note: ''
    }
  },
  methods: {
    ...mapActions('investments/deals', ['updateDeal']),
    ...mapMutations('investments/deals', ['setDealNote']),
    start() {
      this.edit_mode = true;
      this.new_note = this.comment;
      setTimeout(() => {
        this.$refs.input.$refs.textarea.focus()
      }, 200)
    },
    cancel() {
      this.edit_mode = false;
      this.new_note = '';
    },
    save() {
      const data = {
        id: this.id,
        note: this.new_note
      }
      this.isSubmitted = true;
      this.updateDeal(data).then(res => {
        if (res.body.success) {
          this.setDealNote(data)
          this.$toasted.success('Комментарий успешно добавлен')
          this.edit_mode = false;
          this.new_note = '';
        } else {
          this.$toasted.error('Произошла ошибка')
        }
        this.isSubmitted = false;
      });
    }
  },
  i18n: {
    messages: {
      en: {
        commentLabel: 'Your comment',
        save: 'Save',
        cancel: 'Cancel'
      },
      ru: {
        commentLabel: 'Ваш комментарий',
        save: 'Сохранить',
        cancel: 'Отмена'
      }
    }
  }
}
</script>

<style lang="scss">
.comment-icon {
  @apply text-icon ml-4 opacity-0 mt-2 cursor-pointer;
  transition: all .2s;

  &:hover {
    @apply text-icon-hover;
  }

  &.has-comment {
    @apply opacity-100 text-icon-hover;
  }

  &:focus {
    @apply outline-none;
  }
}

.comment-popover.popover {
  .popover-inner {
    @apply p-4 pt-6;
  }

  &:focus {
    @apply outline-none;
  }
}
</style>